/**
 * Organization object
 */
const yup = require('yup');

const {
  requiredString,
  validateObject,
  arrayOf,
  requiredObject
} = require('../utils');

const COLLECTION = 'organizations';
const SCHEMA = yup.object().shape({
  name: requiredString().max(200),
  emails: arrayOf(requiredString()),
  owner: requiredObject().shape({
    uid: requiredString(),
    email: requiredString().email()
  })
});

async function validate(organization) {
  return validateObject(SCHEMA, organization);
}

module.exports = {
  COLLECTION,
  SCHEMA,
  validate
};